import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <motion.div
        className="footer-content"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="footer-info">
          <h3 className="footer-title">The Lida Gallery LLC · Charleston, SC</h3>
          <p className="footer-subtitle">Original Works & Fine Art Prints by Lida Caudle</p>
        </div>
        <div className="footer-copyright">
          <p>© 2025 The Lida Gallery LLC</p>
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer;



